// src/pages/dashboard/user/eventosUser.js
import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    Form,
    Table,
    Alert,
    Row,
    Col,
    Card,
    InputGroup,
} from "@themesberg/react-bootstrap";
import moment from "moment";

export default function EventosUser() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    const [eventos, setEventos] = useState([]);
    const [praticantes, setPraticantes] = useState([]);
    const [eventoPraticantes, setEventoPraticantes] = useState([]);

    const tokenPayload = JSON.parse(atob(token.split('.')[1])); // decodifica JWT
    const userIdFromToken = tokenPayload.id;

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const [showConfirmarModal, setShowConfirmarModal] = useState(false);
    const [confirmarEvento, setConfirmarEvento] = useState(null);
    const [confirmarList, setConfirmarList] = useState([]);
    const [confirmarSearch, setConfirmarSearch] = useState("");

    const [search, setSearch] = useState("");
    const [orderDir, setOrderDir] = useState("asc");
    const [showPast, setShowPast] = useState(false);
    const [orderBy, setOrderBy] = useState("nome");

    // Dentro do componente EventosUser
    const GRADUACOES = [
        { value: 0, nome: "9º Kyu", className: "belt-white" },
        { value: 1, nome: "8º Kyu", className: "belt-yellow" },
        { value: 2, nome: "7º Kyu", className: "belt-orange" },
        { value: 3, nome: "6º Kyu", className: "belt-green" },
        { value: 4, nome: "5º Kyu", className: "belt-blue" },
        { value: 5, nome: "4º Kyu", className: "belt-red" },
        { value: 6, nome: "3º Kyu", className: "belt-brown" },
        { value: 7, nome: "2º Kyu", className: "belt-brown" },
        { value: 8, nome: "1º Kyu", className: "belt-brown" },
        ...Array.from({ length: 10 }, (_, i) => ({
            value: 9 + i,
            nome: `${i + 1}º Dan`,
            className: "belt-black",
        })),
    ];

    const getGraduacaoInfo = (value) =>
        GRADUACOES.find((g) => g.value === value);

// -----------------------
// Abrir modal de confirmação (apenas o próprio praticante)
// -----------------------
    const openConfirmarModal = (ev) => {
        setConfirmarEvento(ev);

        const associados = eventoPraticantes
            .filter(ep => ep.eventoId === ev.id)
            .map(ep => {
                const prat = praticantes.find(p => p.id === ep.praticanteId); // match com lista de praticantes
                return {
                    assocId: ep.id,
                    praticante: prat, // agora garantimos que é definido
                    isConfirmado: ep.isConfirmado === 1 || ep.isConfirmado === true,
                };
            })
            .filter(x => x.praticante); // remove qualquer item sem praticante

        if (associados.length === 0) {
            setError("Não existem praticantes associados a este evento.");
            return;
        }

        setConfirmarList(associados);
        setTimeout(() => setShowConfirmarModal(true), 0);
    };

    const authHeaders = () => ({ Authorization: `Bearer ${token}` });

    useEffect(() => {
        loadAll();
    }, []);

    const loadAll = async () => {
        setLoading(true);
        try {
            const [resE, resP, resEP] = await Promise.all([
                fetch(`${API_BASE_URL}/Eventos`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/Praticantes`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/EventoPraticantes`, { headers: authHeaders() }),
            ]);

            setEventos(resE.ok ? await resE.json() : []);
            const pr = resP.ok ? await resP.json() : [];
            setPraticantes(pr.filter((p) => p.isAtivo === 1 || p.isAtivo === true));
            setEventoPraticantes(resEP.ok ? await resEP.json() : []);
        } catch (err) {
            console.error(err);
            setError("Erro ao carregar dados.");
        } finally {
            setLoading(false);
        }
    };

    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) return null;
        const n = new Date(dataNascimento);
        if (isNaN(n)) return null;

        const hoje = new Date();
        let idade = hoje.getFullYear() - n.getFullYear();
        const m = hoje.getMonth() - n.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < n.getDate())) idade--;
        return idade;
    };

    const getCounts = (eventoId) => {
        const assoc = eventoPraticantes.filter((ep) => ep.eventoId === eventoId);
        const total = assoc.length;
        const confirmed = assoc.filter(
            (a) => a.isConfirmado === 1 || a.isConfirmado === true
        ).length;
        return { total, confirmed };
    };

    // -----------------------
    // Confirmar presença
    // -----------------------

    const getMyId = () => {
        // Implementa isto conforme a tua API/Token
        // Por exemplo, se o id do utilizador estiver no localStorage:
        return parseInt(localStorage.getItem("userId"));
    };

    const toggleConfirmarCheck = (assocId) => {
        setConfirmarList((old) =>
            old.map((x) =>
                x.assocId === assocId ? { ...x, isConfirmado: !x.isConfirmado } : x
            )
        );
    };

    const saveConfirmar = async () => {
        try {
            for (const item of confirmarList) {
                const assoc = eventoPraticantes.find((ep) => ep.id === item.assocId);
                if (!assoc) continue;

                const newVal = item.isConfirmado ? 1 : 0;
                const jaEstavaConfirmado = assoc.isConfirmado === 1 || assoc.isConfirmado === true;

                // 1. Verificamos se houve mudança (seja para marcar ou desmarcar)
                if (Number(assoc.isConfirmado) !== newVal) {

                    // Envia SEMPRE o PUT se o valor mudou
                    const response = await fetch(`${API_BASE_URL}/EventoPraticantes/${assoc.id}`, {
                        method: "PUT",
                        headers: { "Content-Type": "application/json", ...authHeaders() },
                        body: JSON.stringify({ ...assoc, isConfirmado: newVal }), // Enviamos o newVal real
                    });

                    if (!response.ok) throw new Error("Erro ao atualizar base de dados");

                    // 2. APENAS SE for uma nova confirmação (0 -> 1), enviamos a notificação
                    if (!jaEstavaConfirmado && newVal === 1) {
                        const dataEvento = moment(confirmarEvento.data_inicio).format("DD/MM/YYYY");
                        const conteudoNotificacao = `O praticante ${item.praticante.nome} confirmou a presença no evento ${confirmarEvento.nome} a decorrer no dia ${dataEvento}.`;

                        await fetch(`${API_BASE_URL}/Mensagens/notificar-confirmacao`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json", ...authHeaders() },
                            body: JSON.stringify({
                                conteudo: conteudoNotificacao,
                                tipo: "NotificacaoEvento",
                                praticanteId: item.praticante.id
                            }),
                        });
                    }
                }
            }

            setSuccess("Alterações guardadas com sucesso.");
            setShowConfirmarModal(false);
            await loadAll(); // Recarrega os dados para atualizar os contadores na tabela
        } catch (err) {
            console.error(err);
            setError("Erro ao processar as alterações.");
        }
    };

    const eventosProcessados = [...eventos]
        .filter(e => {
            const nomeMatch = e.nome?.toLowerCase().includes(search.toLowerCase());
            const isFuture = moment(e.data_fim).isSameOrAfter(moment());
            return nomeMatch && (showPast || isFuture);
        })
        .sort((a, b) => {
            if (orderBy === "nome") {
                const nA = a.nome?.toLowerCase() || "";
                const nB = b.nome?.toLowerCase() || "";
                if (nA < nB) return orderDir === "asc" ? -1 : 1;
                if (nA > nB) return orderDir === "asc" ? 1 : -1;
                return 0;
            }

            if (orderBy === "data_inicio") {
                const dateA = moment(a.data_inicio);
                const dateB = moment(b.data_inicio);
                return orderDir === "asc" ? dateA - dateB : dateB - dateA;
            }

            return 0;
        });

    return (
        <>
            <div className="py-4">
                <h1 className="font-anton">Eventos</h1>
                <p className="font-open-sans mb-0">
                    Consulte todos os eventos disponíveis e garanta a sua presença.
                </p>
            </div>

            {error && (
                <Alert variant="danger" onClose={() => setError("")} dismissible>
                    {error}
                </Alert>
            )}
            {success && (
                <Alert variant="success" onClose={() => setSuccess("")} dismissible>
                    {success}
                </Alert>
            )}

            {/* Filtros */}
            <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} sm={6}>
                    <Form.Control
                        placeholder="Pesquisar por nome..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Col>
                <Col xs={6} sm={3}>
                    <Form.Select value={orderDir} onChange={e => setOrderDir(e.target.value)}>
                        <option value="asc">Mais antigo</option>
                        <option value="desc">Mais novo</option>
                    </Form.Select>
                </Col>
                <Col xs={6} sm={3} className="d-flex align-items-center">
                    <Form.Check
                        type="checkbox"
                        label="Mostrar passados"
                        checked={showPast}
                        onChange={() => setShowPast(!showPast)}
                    />
                </Col>
            </Row>

            {/* Tabela — visível em ecrãs médios+ */}
            <div className="d-none d-md-block">
                <Card className="shadow-sm mb-4">
                    <Card.Body>
                        <Table responsive hover>
                            <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Tipo</th>
                                <th>Localidade</th>
                                <th>Data</th>
                                <th>Confirmados / Total</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {eventosProcessados.map((e) => {
                                const counts = getCounts(e.id);
                                return (
                                    <tr key={e.id}>
                                        <td className="fw-bold">{e.nome}</td>
                                        <td>{e.tipoEvento}</td>
                                        <td>{e.localidade}</td>
                                        <td>
                                            {moment(e.data_inicio).format("DD/MM/YYYY")} –{" "}
                                            {moment(e.data_fim).format("DD/MM/YYYY")}
                                        </td>
                                        <td>
                                            <span className="fw-bold text-success">{counts.confirmed}</span>
                                            <span className="text-muted"> / {counts.total}</span>
                                        </td>
                                        <td>
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={() => openConfirmarModal(e)}
                                            >
                                                ✓ Confirmar Presença
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                            {eventosProcessados.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-4">
                                        Nenhum evento encontrado.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — visível apenas em mobile */}
            <div className="d-md-none">
                {eventosProcessados.length === 0 && (
                    <p className="text-center text-muted py-4">Nenhum evento encontrado.</p>
                )}
                {eventosProcessados.map((e) => {
                    const counts = getCounts(e.id);
                    const isPast = moment(e.data_fim).isBefore(moment());
                    return (
                        <Card key={e.id} className="mb-3 shadow-sm">
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <h6 className="fw-bold mb-1">{e.nome}</h6>
                                        {e.tipoEvento && (
                                            <span className="badge bg-secondary me-1">{e.tipoEvento}</span>
                                        )}
                                        {isPast && (
                                            <span className="badge bg-light text-muted border">Passado</span>
                                        )}
                                    </div>
                                </div>

                                <div className="small text-muted mb-1">
                                    📍 {e.localidade || "—"}
                                </div>
                                <div className="small text-muted mb-1">
                                    📅 {moment(e.data_inicio).format("DD/MM/YYYY")}
                                    {e.data_inicio !== e.data_fim && ` → ${moment(e.data_fim).format("DD/MM/YYYY")}`}
                                </div>
                                {(e.hora_inicio || e.hora_fim) && (
                                    <div className="small text-muted mb-2">
                                        🕐 {e.hora_inicio} – {e.hora_fim}
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                                    <span className="small">
                                        <span className="fw-bold text-success">{counts.confirmed}</span>
                                        <span className="text-muted"> / {counts.total} confirmados</span>
                                    </span>
                                    <Button
                                        size="sm"
                                        variant="success"
                                        onClick={() => openConfirmarModal(e)}
                                    >
                                        ✓ Confirmar Presença
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    );
                })}
            </div>

            {/* Modal Confirmar Presença — redesenhado para mobile */}
            <Modal
                size="md"
                show={showConfirmarModal}
                centered
                onHide={() => setShowConfirmarModal(false)}
            >
                <Modal.Header closeButton className="border-bottom pb-3">
                    <div>
                        <Modal.Title className="h5 mb-0">Confirmar Presença</Modal.Title>
                        {confirmarEvento && (
                            <div className="small text-muted mt-1">
                                <strong>{confirmarEvento.nome}</strong>
                                {" · "}
                                {moment(confirmarEvento.data_inicio).format("DD/MM/YYYY")}
                            </div>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {confirmarList.length === 0 ? (
                        <p className="text-center text-muted py-4">Nenhum praticante associado a este evento.</p>
                    ) : (
                        <div>
                            {/* Instrução clara */}
                            <div className="px-3 pt-3 pb-2 bg-light border-bottom">
                                <small className="text-muted">
                                    Marque os praticantes que vão participar neste evento e toque em <strong>Guardar</strong>.
                                </small>
                            </div>

                            {/* Lista de praticantes — sem tabela, fácil de tocar */}
                            <div className="list-group list-group-flush">
                                {confirmarList.map((item) => {
                                    const g = getGraduacaoInfo(item.praticante.graduacao);
                                    const idade = calcularIdade(item.praticante.dataNascimento);
                                    return (
                                        <label
                                            key={item.assocId}
                                            className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 px-3"
                                            style={{ cursor: "pointer", minHeight: 64 }}
                                        >
                                            {/* Checkbox grande para mobile */}
                                            <div
                                                onClick={() => toggleConfirmarCheck(item.assocId)}
                                                style={{
                                                    width: 28,
                                                    height: 28,
                                                    minWidth: 28,
                                                    borderRadius: 6,
                                                    border: `2px solid ${item.isConfirmado ? "#198754" : "#adb5bd"}`,
                                                    backgroundColor: item.isConfirmado ? "#198754" : "white",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    transition: "all 0.15s",
                                                    cursor: "pointer",
                                                    flexShrink: 0
                                                }}
                                            >
                                                {item.isConfirmado && (
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="white">
                                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                                    </svg>
                                                )}
                                            </div>

                                            {/* Info do praticante */}
                                            <div className="flex-grow-1 overflow-hidden" onClick={() => toggleConfirmarCheck(item.assocId)}>
                                                <div className="fw-bold text-truncate">{item.praticante.nome}</div>
                                                <div className="d-flex align-items-center gap-2 mt-1 flex-wrap">
                                                    {idade !== null && (
                                                        <span className="small text-muted">{idade} anos</span>
                                                    )}
                                                    {g && (
                                                        <span className={`belt-badge ${g.className}`} style={{ fontSize: 11 }}>
                                                            {g.nome}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Badge de estado visual */}
                                            <div className="flex-shrink-0">
                                                <span
                                                    className="badge"
                                                    style={{
                                                        backgroundColor: item.isConfirmado ? "#d1fae5" : "#f3f4f6",
                                                        color: item.isConfirmado ? "#065f46" : "#6b7280",
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                        padding: "4px 8px",
                                                        borderRadius: 20,
                                                    }}
                                                >
                                                    {item.isConfirmado ? "Confirmado" : "Pendente"}
                                                </span>
                                            </div>
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top pt-3 gap-2">
                    <Button
                        variant="outline-secondary"
                        className="flex-grow-1 flex-sm-grow-0"
                        onClick={() => setShowConfirmarModal(false)}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="success"
                        className="flex-grow-1 flex-sm-grow-0"
                        onClick={saveConfirmar}
                        disabled={confirmarList.length === 0}
                    >
                        ✓ Guardar Presenças
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}